export default () => ({
	legacy: false,
	locale: "de"
});
